import { render, staticRenderFns } from "./smartSingleSelection.vue?vue&type=template&id=35fda42f&scoped=true&lang=html&"
import script from "./smartSingleSelection.vue?vue&type=script&lang=js&"
export * from "./smartSingleSelection.vue?vue&type=script&lang=js&"
import style0 from "./smartSingleSelection.vue?vue&type=style&index=0&id=35fda42f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fda42f",
  null
  
)

export default component.exports